import { cn } from '@/utils';

function Spinner({ className, size = 24, ...props }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			strokeLinecap="round"
			height={size}
			width={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinejoin="round"
			className={cn('animate-spin', className)}
			{...props}
		>
			<path d="M21 12a9 9 0 1 1-6.219-8.56" />
		</svg>
	);
}

export default Spinner;
